<div class="notes-modal">
  <div class="notes-modal-header">
    <div class="header-text">
      {{data.isEditMode ? 'Edit' : 'Add'}} note
    </div>
    <button
      mat-flat-button
      class="md circle expandable"
      (click)="expandDialog()"
    >
      <mat-icon>open_in_full</mat-icon>
    </button>
    <button
      mat-flat-button
      class="md circle"
      (click)="saveAsDraft()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div
    class="notes-modal-content"
    [formGroup]="form"
  >
    <mat-form-field
      color="accent"
      class="w-100 mr-sm-2"
    >
      <input
        matInput
        formControlName="title"
        autocomplete="off"
        placeholder="Subject"
        required
      >
    </mat-form-field>
    <mojo-editor
      [hasTalentPoolFeatureExtension]="talentPoolsService.hasTalentPoolPrivilegeAndFe() | async"
      [hasAnonymization]="hasAnonymization$ | async"
      [material]="true"
      [expandable]="false"
      [showCandidateMentionTags]="showMentionTags"
      [showUserMentionTags]="noteVisibility.value !== privateNote && showMentionTags"
      [allowedTeamMembers]="teamMembersForMentions"
      [allowedNumberOfFiles]="allowedNumberOfFiles"
      placeholder="Description"
      class="form-control-editor"
      formControlName="message"
      [alert]="alertCallback"
      (uploadedFiles)="uploadFiles($event)"
    >
    </mojo-editor>
    <div class="attachments">
      <div
        class="attachment-item"
        *ngFor="let attachment of attachments"
      >
        <mat-icon>attach_file</mat-icon>
        <div class="file-details">
          <span>{{getFileNameWithoutExtension(attachment?.name)}}</span>
          <span class="file-extension">{{getExtension(attachment?.name)}}</span>
        </div>
        <mat-icon
          (click)="deleteAttachment(attachment)"
          class="material-icons-outlined close-icon"
        >close</mat-icon>
      </div>
    </div>

  </div>
  <div class="notes-modal-footer">
    <button
      type="submit"
      color="primary"
      mat-raised-button
      class="sm submit-button"
      (click)="submit()"
    > {{data.isEditMode && data.note?.category !== 'draft' ? 'SAVE' : 'ADD'}}
    </button>
    <div
      class="note-visibility w-80"
      [matTooltip]="(tooltip$ | async) || editTooltip"
      [matTooltipDisabled]="noteVisibility.value !== sharedNote"
      matTooltipClass="note-visibility-tooltip"
    >
      <mat-label>Visibility: </mat-label>
      <mat-select
        [formControl]="noteVisibility"
        disableOptionCentering
        panelClass="note-visibility-selection"
      >
        <mat-option
          *ngFor="let option of visibilityOptions"
          [value]="option.value"
          (click)="openTeamMembersModal(option.value)"
        >
          <mat-radio-button [checked]="option.value === noteVisibility.value">
            {{
            (currentTeamMembers?.length > 0 && option.value === sharedNote)
              ? 'Me +' + currentTeamMembers?.length
              : option.label
            }}
          </mat-radio-button>
        </mat-option>
      </mat-select>
    </div>
    <div class="buttons">
      <span
        class="delete"
        (click)="discardNote()"
      >
        <mat-icon>delete</mat-icon>
      </span>
    </div>
  </div>
</div>
